var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 3.54297C6.43213 3.54297 3.5415 6.45964 3.5415 10.0013C3.5415 13.569 6.43213 16.4596 9.99984 16.4596C13.5415 16.4596 16.4582 13.569 16.4582 10.0013C16.4582 6.45964 13.5415 3.54297 9.99984 3.54297ZM9.99984 4.79297C12.8644 4.79297 15.2082 7.13672 15.2082 10.0013C15.2082 12.8919 12.8644 15.2096 9.99984 15.2096C7.10921 15.2096 4.7915 12.8919 4.7915 10.0013C4.7915 7.13672 7.10921 4.79297 9.99984 4.79297ZM13.6457 8.20443L13.0467 7.60547C12.9425 7.47526 12.7342 7.47526 12.604 7.60547L8.93213 11.2513L7.36963 9.6888C7.23942 9.55859 7.05713 9.55859 6.92692 9.6888L6.32796 10.2617C6.2238 10.3919 6.2238 10.6003 6.32796 10.7044L8.69775 13.1003C8.82796 13.2305 9.01025 13.2305 9.14046 13.1003L13.6457 8.64714C13.7498 8.51693 13.7498 8.30859 13.6457 8.20443Z",
    fill: "#8B909A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.5053a6801ff0c06f4d408611a8a548d3.svg";
export { ForwardRef as ReactComponent };